import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import Spinner from '../common/Spinner';
import ShortcutsWrapper from './ShortcutsWrapper';
import CustomPlaylists from '../custom/-APP_TARGET/content/CustomPlaylists';

import useListScroll from './hooks/useListScroll';

function ConnectedPlaylists({ list, loadMore = null, isLoading, filter = '', style }) {
  const filterPlaylists = (x) => filter === '' || ( x.name && x.name.toLowerCase().includes(filter.toLowerCase()) );
  const { ref, onScroll } = useListScroll(list, loadMore, filter)

  return (
    <div id={'my-playlists'} ref={ref} onScroll={onScroll} style={{ height: `auto`, overflowY: `auto`, margin: `0px 8px 0px 8px`, ...style}}>
      { !list || isLoading
        ? <Spinner style={{ marginLeft: 16 }} />
        : (
          <>
            <ShortcutsWrapper playlists={list.filter(filterPlaylists).map(x => x.id)} />
            <CustomPlaylists list={list.filter(filterPlaylists)} containerRef={ref} />
          </>
        )
      }
    </div>
  )
}

ConnectedPlaylists.propTypes = {
  list: PropTypes.any,
  filter: PropTypes.string,
  style: PropTypes.object,
}

const Playlists = connect(
  state => ({
    list: state.storePlaylists ? state.storePlaylists.playlists : null,
    loadMore: state.storePlaylists ? state.storePlaylists.loadMore : null,
    isLoading: state.storePlaylists ? state.storePlaylists.isLoading : false,
  })
)(ConnectedPlaylists);

export default Playlists;
